import { STORE_CONTENT,  STORE_AND_UPDATE_CONTENT, STORE_MAIN_DIALOG_CONTENT} from '../constants/actionConstants';
import { preprocess_problems } from '../components/Global/ProblemUtils';
import { update_frame_states } from '../components/Global/utils';

// content -- current section we are reading

const ContentReducer =  (state = {content:[], problemIds:[], mainDialogContent:undefined}, action) =>{
    switch(action.type)
    {
        // Stores the current content loaded from the database
        // Also preprocess the problems so easier to find which ones have been tried
        // Also makes list of references to subsection / figure / equation numbers and the section that they belong to
        case STORE_CONTENT:     
            return {...state, content: action.payload, problemIds:preprocess_problems(action.payload)}

        // Updates the current content in the editor
        // (Just one content element)
        case STORE_AND_UPDATE_CONTENT:
            // Update the number of states in each frame
            var contentCopy = update_frame_states(action.payload)
            // Just replace the current content
            return {...state, content: contentCopy }; 
    
        case STORE_MAIN_DIALOG_CONTENT:
            return {...state, mainDialogContent:action.payload}
        default:
            return state ; 
    }
    
} ; 

export default ContentReducer ; 